import { Flex } from "@similarweb/ui-components/foundations";

import { MetricWrapper } from "app/pages/benchmark-tracker/components/Report/MetricElements/TrafficShare/styles";
import type { TrafficShareCompetitorSchema } from "app/pages/benchmark-tracker/types/api.types";

import { Header } from "./Header";
import { PeriodBlock } from "./PeriodBlock";
import { ShareBlock } from "./ShareBlock";

type MyTrafficShareSchema = {
    tooltip: string;
    share: TrafficShareCompetitorSchema["share"];
    shareTrend: TrafficShareCompetitorSchema["shareTrend"];
    yoy: TrafficShareCompetitorSchema["yearOverYearShareDifference"];
    pop: TrafficShareCompetitorSchema["periodOverPeriodShareDifference"];
    isLoading: boolean;
};

export const MyTrafficShare = ({ tooltip, shareTrend, yoy, pop, share, isLoading }: MyTrafficShareSchema) => {
    return (
        <MetricWrapper width="40%">
            <Header tooltip={tooltip} />

            <Flex>
                <ShareBlock
                    percentageValue={share}
                    shareTrend={shareTrend}
                    isLoading={isLoading}
                />

                <PeriodBlock
                    yoy={yoy}
                    pop={pop}
                    isLoading={isLoading}
                />
            </Flex>
        </MetricWrapper>
    );
};
